import { Controller } from "@hotwired/stimulus";

// Debounced live-ish search — a real SSR page reload per keystroke would be
// unusable, so this waits for a short pause in typing before submitting the form
// (`this.element` is the `<form>` itself, per the root `data-controller` in
// market_navbar_component.html.erb), same idea as the SPA's own live search just
// implemented as a page navigation instead of a client-side re-render.
export default class extends Controller {
  static DEBOUNCE_MS = 400;

  connect() {
    this.timeout = null;
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  debounceSubmit() {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.element.requestSubmit();
    }, this.constructor.DEBOUNCE_MS);
  }
}
